import { checkStandardApiError } from "../../../../components-shared/api/base/error-handling.js";
import { IOrderDiscount } from "./interfaces/order-discount.js";

export class OrderDiscountApi{
    public async getOrderDiscounts(){
        const response = await fetch(`/api/estore/discount/order-discounts`);

        if (!await checkStandardApiError(response, true, (msg) => { console.error(msg) })){
            return null;
        }
        
        return await response.json() as IOrderDiscount[];
    }
}